import Config from "@Configs/apiConfig";

/**
 * Call to renew token endpoint
 *
 */
async function renew() {
  // call the endpoint and update token in local storage
  await callRenewAndUpdateToken(
    localStorage.getItem("Email"),
    localStorage.getItem("renew_token")
  );
}

async function callRenewAndUpdateToken(email, renew_token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("Token"),
    },
    body: JSON.stringify({ email, renew_token }),
  };
  const response = await fetch(
    Config.loginServer + "/login/renew",
    requestOptions
  );

  if (!response.ok) {
    throw new Error("Token renew failed");
  }
  const resptext = await response.text();
  const respObj = JSON.parse(resptext);
  const userData = JSON.parse(atob(respObj.token.split(".")[1]));


  localStorage.setItem("LoginName", userData.email);
  localStorage.setItem("ownParty", userData.ownParty);
  localStorage.setItem("Token", respObj.token);
  localStorage.setItem("Id", userData.userid);
  localStorage.setItem("UserName", userData.username);
  localStorage.setItem("Name", userData.Name);
  localStorage.setItem("FirstName", userData.userFirstName);
  localStorage.setItem("LastName", userData.userLastName);
  localStorage.setItem("Email", userData.email);
  localStorage.setItem("CultureID", userData.cultureId);
  localStorage.setItem("CustomerID", userData.customerID);
  localStorage.setItem("AvatarID", userData.avatarID);
  localStorage.setItem("AvatarImage", "");
  localStorage.setItem("IAT", userData.iat);
  localStorage.setItem("CD", userData.cd);
  localStorage.setItem("RoleID", userData.userRoleID);
  localStorage.setItem("renew_token", userData.renew_token);
  localStorage.setItem(
    "ShowSkipDocumentation",
    userData.showSkipDocumentationEnabled
  );
  localStorage.setItem(
    "media_info_config",
    JSON.stringify(userData.media_info_config)
  );
}

/**
 * Fetch helper wraps all requests of services
 * to handle a token timeout.
 *
 * If timout occurs, all reqeusts will be queued until
 * token refresh is finished. All Queued requests will be
 * resend with new token.
 *
 *
 */
class fetch_helper {
  constructor() {
    this.renew = renew;
  }

  /**
   * Fetch Wrapper which should used in every service call.
   *
   * @param {string} url Requets URL of the fetch
   * @param {object} options Request options
   * @returns {object} Response Ojbect
   */
  async fetch(url, options) {
    try {
      // first do the real fetch call
      var resp = null;
      resp = await fetch(url, {
        method: options.method,
        headers: { ...options.headers },
        body: options.data,
      });

      // if response is not OK throw Error to go into catch.
      // (409 will not throw error by itself)
      if (!resp.ok) throw resp;

      // if there was a renew before we can not delete because
      // call was successfull
      localStorage.removeItem("isRenewing");

      // return response
      return resp;
    } catch (e) {
      // The catch part cant be interrupted by
      // so  we are singlethreaded here
      if (e.status === 401) {
        // check if we are already in Renewing procedure
        if (localStorage.getItem("isRenewing")) {
          // ok we are alreacy renewing
          // we have to wait for this requests until renew is done
          // we use timeout for this
          while (localStorage.getItem("isRenewing"))
            await new Promise((reslve) => setTimeout(reslve, 500));

          // since we the new token is now available we have to update
          // the auth header of the requets
          options = {
            ...options,
            headers: {
              ...options.headers,
               "x-access-token": localStorage.getItem("Token"),
            },
          };

          // now we try again with the new token
          return await fetch(url, options);
        }

        // we are not renewing (this is the first call that failed)
        // set globally that we are in renew procedure
        localStorage.setItem("isRenewing", "true");

        var responseJson = await e.json();

        if (responseJson.error_message === "Token expired") {
          //get a new thoken
          await renew();

          // ok renew is done
          // since this request failed before we have to update its
          // token
          options = {
            ...options,
            headers: {
              ...options.headers,
              "x-access-token": localStorage.getItem("Token"),
            },
          };

          // and now try call again
          var resp2 = await fetch(url, options);

          // we can stop the renew procedure to release all waiting
          // requests
          localStorage.removeItem("isRenewing");
          return resp2;
        } else {
          localStorage.removeItem("isRenewing");
          // since we already read the body we
          // set it in response object
          const err = new Error(e.status);
          err.response = resp;
          throw err;
        }
      } else {
        const err = new Error(e.status);
        err.response = resp;
        throw err;
      }
    }
  }
}

export default new fetch_helper();
